const sortSingleObjectKeys = <O extends Record<string, unknown>>(obj: O) => {
  if (!isObjectAsWeCommonlyCallIt(obj)) return obj
  return Object.keys(obj)
    .sort()
    .reduce((acc, key) => {
      acc[key as keyof O] = obj[key as keyof O]
      return acc
    }, {} as O)
}

export const sortObjectKeys = <O extends Record<string, unknown>>(obj: O) => {
  const sortedObj = sortSingleObjectKeys(obj)

  if (!isObjectAsWeCommonlyCallIt(sortedObj)) return sortedObj

  Object.keys(sortedObj).forEach((key) => {
    if (isObjectAsWeCommonlyCallIt(sortedObj[key as keyof O])) {
      sortedObj[key as keyof O] = sortObjectKeys(
        sortedObj[key as keyof O] as O
      ) as O[keyof O]
    } else if (Array.isArray(sortedObj[key as keyof O])) {
      sortedObj[key as keyof O] = (sortedObj[key as keyof O] as unknown[]).map(
        (item) => {
          if (isObjectAsWeCommonlyCallIt(item)) {
            return sortObjectKeys(item)
          } else {
            return item
          }
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ) as any
    }
  })

  return sortedObj
}

/**
 * typeof obj returns 'object' for null, arrays, functions... so we are more strict here.
 */
export const isObjectAsWeCommonlyCallIt = (
  obj: unknown
): obj is Record<string, unknown> => {
  return Object.prototype.toString.call(obj) === '[object Object]'
}
